<html>

     <!----------------------------------------------------------------------->
     <body class="dx-viewport">

        <dx-box
            direction="row"
            width="100%"
            [height]="windowHeight"
        >
            <!-----------------------------------------------------------------------> 
                <dxi-item
                    [ratio]="8"
                >

                    <div>

                        <dx-drawer 
                            [openedStateMode]="selectedOpenMode"
                            [position]="selectedPosition"
                            [revealMode]="selectedRevealMode"
                            template="template"
                            [(opened)]="isDrawerOpen"
                            [height]="windowHeight"
                            [closeOnOutsideClick]="isCloseOutsideClick"
                        >

                                <div *dxTemplate="let data of 'template'" style="width: 290px">
                                    
                                    <div class="listborder"> 

                                        <dx-list 
                                            #list
                                            [dataSource]="navigation"
                                            [hoverStateEnabled]="true"
                                            [activeStateEnabled]="true"
                                            [focusStateEnabled]="true"
                                        
                                            [grouped]="true"
                                            [collapsibleGroups]="true" 

                                            (onItemClick)="menutargetclick($event)"     
                                        >

                                            <div *dxTemplate="let item of 'group'">
                                                <div>{{item.key}}</div>
                                            </div>

                                        </dx-list>
                                        
                                    </div>
                                    

                                </div>
                                <!----------------------------------------------------------------------->
                                <div>
                                    <router-outlet></router-outlet>
                                </div>
                                <!----------------------------------------------------------------------->


                        </dx-drawer>

                    </div>
                    <!----------------------------------------------------------------------->

                </dxi-item>


        </dx-box>    

    </body>
    <!----------------------------------------------------------------------->

</html>
